import React, { createContext } from 'react';

import DefaultPersonalizationConfig from './DefaultPersonalizationConfig';

import PersonalizationConfig from './PersonalizationConfig';

// Create the context
const PersonalizationContext = createContext<{
    personalizationConfig: PersonalizationConfig;
    setPersonalizationConfig: React.Dispatch<React.SetStateAction<PersonalizationConfig>>;
}>({
    personalizationConfig: DefaultPersonalizationConfig,
    setPersonalizationConfig: () => {},
});

export default PersonalizationContext;